import React from 'react';

import styled from 'styled-components';

import { AccentBadge } from './accent-badge';
import { IBadgeProps } from './types';

const Badge = styled(AccentBadge)`
  background-color: transparent;
  padding: 0;
  margin: 4px 0 0 0;
`;

export const LoginRequiredBadge: React.FC<IBadgeProps> = ({ formatMessage }) => (
  <Badge data-testid="login-required-badge">{formatMessage({ id: 'signUpToRedeem' })}</Badge>
);
